import {
  SalesforceFieldMapping,
  SalesforceSyncTypes,
} from 'module/api/integrations/salesforce/types';
import {
  PartialSalesforceFieldMappingLocalData,
  SalesforceFieldMappingLocalData,
} from 'module/api/integrations/salesforce/types';
import { ISingleValue as SingleValue } from 'module/ui/components/atoms/select';
import { omit, uniqueId } from 'lodash';

export const getNewMap = (
  integrationId: number,
  resouceMappingConfigId: number,
  externalField: SingleValue,
): PartialSalesforceFieldMappingLocalData => ({
  id: uniqueId(),
  integrationId,
  resouceMappingConfigId,
  salesforceField: externalField,
  syncField: externalField?.extra
    ? SalesforceSyncTypes.SyncNativeToExternal
    : SalesforceSyncTypes.SyncExternalToNative,
  rocketlaneField: undefined,
});

export const serialiseMappingData = (
  mapping: SalesforceFieldMappingLocalData,
): SalesforceFieldMapping | undefined => {
  if (mapping.salesforceField && mapping.rocketlaneField && mapping.syncField) {
    return {
      ...omit(mapping, 'salesforceField', 'rocketlaneField', 'syncField', 'id'),
      integrationId: mapping.integrationId,
      externalIntegrationType: 'salesforce',
      nativeFieldId: Number(mapping.rocketlaneField.value),
      nativeFieldLabel: mapping.rocketlaneField.label,
      nativeFieldName:
        mapping.rocketlaneField?.name ??
        mapping.rocketlaneField.extra?.fieldName,
      externalFieldId: mapping.salesforceField.value.toString(),
      externalFieldName: mapping.salesforceField.label!,
      syncType: mapping.syncField,
      enabled: true,
    };
  }

  return undefined;
};
